import { Avatar, Box, Chip, Typography } from '@mui/material'
import { FC } from 'react'

interface StepProps {
  number: number
  icon: React.ReactNode
  iconBg: string
  iconColor: string
  title: string
  children: React.ReactNode
  last?: boolean
}

export const Step: FC<StepProps> = ({ number, icon, iconBg, iconColor, title, children, last }) => (
  <Box sx={{ display: 'flex', gap: 2.5, mb: last ? 0 : 1 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Avatar sx={{ bgcolor: iconBg, width: 40, height: 40, fontSize: 14 }}>
        <Box sx={{ color: iconColor, display: 'flex' }}>{icon}</Box>
      </Avatar>
      {!last && (
        <Box sx={{ width: 2, flexGrow: 1, bgcolor: 'divider', mt: 1, mb: 0.5, borderRadius: 1 }} />
      )}
    </Box>
    <Box sx={{ flexGrow: 1, pb: last ? 0 : 3, minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 0.75 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Chip label={number} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 600 }} />
      </Box>
      {children}
    </Box>
  </Box>
)
